import React from 'react';
const bonuses = [{
  num: '01',
  label: '🎁 BONO 1',
  title: 'Modo Antialgoritmo: Blindaje Digital Total',
  desc: 'Configuración paso a paso para iPhone y Android. Convertí tu celular en una herramienta de trabajo y no en una trampa de dopamina.',
  price: '$12.000'
}, {
  num: '02',
  label: '🎁 BONO 2',
  title: 'Tablero de Control 90 Días',
  desc: 'Sistema de seguimiento diario, semanal y mensual para que veas tu progreso en tiempo real y nunca pierdas el rumbo.',
  price: '$9.000'
}, {
  num: '03',
  label: '🎁 BONO 3',
  title: 'Protocolo de Apagado Mental (7 minutos)',
  desc: 'La rutina nocturna exacta para cerrar el día sin culpa, dormir mejor y arrancar el día siguiente con energía real.',
  price: '$10.000'
}, {
  num: '04',
  label: '🎁 BONO 4',
  title: 'Scripts de Arranque en Foco Profundo',
  desc: '12 scripts de 3 minutos para entrar en estado de flujo sin excusas. Para los días que no tenés ganas de nada.',
  price: '$9.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-41">
      <div className="mx-auto max-w-4xl" data-id="element-42">
        {/* Heading */}
        <div className="mb-6 text-center" data-id="element-43">
          <h2 className="text-3xl font-black leading-10 text-white m-0 mb-2" data-id="element-44">
            Más los{' '}
            <span className="text-yellow-400" data-id="element-45">4 Bonos Exclusivos</span>
          </h2>
          <p className="text-sm text-gray-400 m-0" data-id="element-46">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* Bonus Cards Grid */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4" data-id="element-47">
          {bonuses.map(bonus => <div key={bonus.num} className="flex flex-col rounded-xl p-4 shadow-sm" style={{
          backgroundColor: 'rgba(234, 179, 8, 0.05)',
          border: '1px solid rgba(234, 179, 8, 0.3)'
        }} data-id="element-48">
              <div className="mb-1 text-2xl leading-8 font-black text-yellow-400" data-id="element-49">
                {bonus.num}
              </div>
              <div className="mb-1 text-[10px] font-bold uppercase tracking-[1.2px] text-yellow-400" data-id="element-50">
                {bonus.label}
              </div>
              <h3 className="text-sm font-black text-white m-0 mb-1" data-id="element-51">
                {bonus.title}
              </h3>
              <p className="flex-1 text-xs text-gray-400 m-0 mb-3" data-id="element-52">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-xs text-gray-500 line-through" data-id="element-54">
                  {bonus.price}
                </span>
                <span className="bg-yellow-400 text-[10px] font-black text-gray-900 rounded-full px-2 py-0.5" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value Footer */}
        <div className="mx-auto max-w-2xl text-center rounded-xl p-4 shadow-sm" style={{
        backgroundColor: 'rgba(234, 179, 8, 0.05)',
        border: '1px solid rgba(234, 179, 8, 0.3)'
      }} data-id="element-56">
          <p className="text-xs font-semibold uppercase tracking-[1.4px] text-yellow-400 m-0 mb-1" data-id="element-57">
            Valor total de los 4 Bonos
          </p>
          <div className="mb-1 flex flex-col sm:flex-row items-center justify-center gap-2" data-id="element-58">
            <span className="text-base text-gray-500 line-through" data-id="element-59">
              $40.000
            </span>
            <span className="text-base sm:text-xl font-black tracking-wide text-yellow-400" data-id="element-60">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
          <p className="text-xs text-gray-400 m-0" data-id="element-61">
            Incluidos en todas las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}